import type { ReactNode } from 'react';
import { ChatSurfaceIcons } from '../context/types';

/**
 * Default inline-SVG icon set. Consumers can override any icon via the
 * ChatSurfaceProvider's `icons` prop. Icons use `currentColor` so they
 * inherit the consumer's color tokens.
 */
const Svg = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const defaultIcons: ChatSurfaceIcons = {
  Close: ({ className }) => (
    <Svg className={className}>
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  ),
  Play: ({ className }) => (
    <Svg className={className}>
      <path d="M8 5v14l11-7z" fill="currentColor" />
    </Svg>
  ),
  Pdf: ({ className }) => (
    <Svg className={className}>
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" fill="none" />
    </Svg>
  ),
  Txt: ({ className }) => (
    <Svg className={className}>
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path d="M14 2v6h6M8 13h8M8 17h8" stroke="currentColor" strokeWidth="2" />
    </Svg>
  ),
  Diagram: ({ className }) => (
    <Svg className={className}>
      <rect
        x="4"
        y="4"
        width="6"
        height="6"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="14"
        y="4"
        width="6"
        height="6"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="9"
        y="14"
        width="6"
        height="6"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </Svg>
  ),
  Summary: ({ className }) => (
    <Svg className={className}>
      <path
        d="M4 6h16M4 12h12M4 18h8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  ),
  ArrowExpand: ({ className }) => (
    <Svg className={className}>
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  ),
  ArrowCollapse: ({ className }) => (
    <Svg className={className}>
      <path
        d="M6 15l6-6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  ),
  ThumbsUp: ({ className }) => (
    <Svg className={className}>
      <path
        d="M7 10v10H4V10h3zm3 10h7a2 2 0 0 0 2-1.7l1-7A2 2 0 0 0 18 9h-4l.7-3.7A1.5 1.5 0 0 0 13 3.5c-.5 0-1 .3-1.3.7L10 8v12z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  ),
  ThumbsDown: ({ className }) => (
    <Svg className={className}>
      <path
        d="M7 14V4H4v10h3zm3-10h7a2 2 0 0 1 2 1.7l1 7A2 2 0 0 1 18 15h-4l.7 3.7A1.5 1.5 0 0 1 13 20.5c-.5 0-1-.3-1.3-.7L10 16V4z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  ),
};
